<!-- <p>blog-content works!</p> -->
<div *ngIf="blog" class="main-container">
  <h1>{{blog.title}}</h1>
  <hr>
  <p class="text-ITI">ITI Mutual Funds</p>
  <p [innerHTML]="blog.content"></p>
  <div class="container">
    <span class="share">Share:</span>
    <div class="flex-box">
      <img src="assets/ITI-IAP-HTML/images/facebook.png" alt="Facebook" (click)="redirectToSocialMedia('facebook')">
      <img src="assets/ITI-IAP-HTML/images/whatsapp.png" alt="WhatsApp" (click)="redirectToSocialMedia('whatsapp')">
      <img src="assets/ITI-IAP-HTML/images/twitter.png" alt="Twitter" (click)="redirectToSocialMedia('twitter')">
      <img src="assets/ITI-IAP-HTML/images/linkedin.png" alt="LinkedIn" (click)="redirectToSocialMedia('linkedin')">
    </div>  
  </div>
  <hr class="btm-margin">
<div *ngIf="blog.similarArticles && blog.similarArticles.length>0">
  <p class="heading">Blogs you might like:</p>
  <div class="row row-vw blogs-row">
    <div class="col-lg-4" *ngFor="let article of blog.similarArticles">
      <div class="watchBx" (click)="getArticle(article.id)">
        <div class="yt-img position-relative mrg-b-15">
          <picture class="w-100 d-block infographic">
            <source [srcset]="article.imagePath"
              class="w-100 deskImg image-fit thumbnail-img">
            <img [src]="article.imagePath" alt="Video Thumbnail"
              class="w-100 mobImg image-fit thumbnail-img" loading="lazy">
          </picture>

        </div>
        <div style="width: 50%;">
          <span>{{article.title}}</span>
        </div>

      </div>
    </div>
   

  </div>
</div>